import React, { memo, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import * as modals from '../../constants/modals';

import ModalRestoreAll from './RestoreAll';
import ModalRestore from './Restore';
import { ServicesDeletedContext } from '../../index';
import { modalClose } from '../../reducer';

const Modals = () => {
  const [store, dispatch] = useContext(ServicesDeletedContext);
  const { modal } = store;
  const onClose = () => {
    dispatch(modalClose())
  };

  const modalsComponentsList = [
    {
      name: modals.RESTORE_ALL,
      Component: ModalRestoreAll,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: modals.RESTORE,
      Component: ModalRestore,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
  ]

  if (modalsComponentsList.length) {
    return modalsComponentsList.map((item) => {
      const { Component, options, name } = item;
      const showModal = modal?.name === name;

      return (
        <Modal
          key={name}
          show={showModal}
          backdrop="static"
          onHide={onClose}
          {...options}
        >
          <Component />
        </Modal>
      )
    })
  }
  return null;
};

Modals.propTypes = {
  modal: PropTypes.object,
}

const arePropsEqual = (prevProps, nextProps) => _.isEqual(prevProps.modal, nextProps.modal)
export default memo(Modals, arePropsEqual)
